import React from 'react';
import { Loader, Inbox, AlertTriangle, WifiOff } from 'lucide-react';
import './States.css';

export function LoadingState({ label = 'Chargement...' }) {
  return (
    <div className="ui-state">
      <Loader className="ui-state-spin" size={28} />
      <p>{label}</p>
    </div>
  );
}

export function EmptyState({ label = 'Aucune donnée' }) {
  return (
    <div className="ui-state">
      <Inbox size={28} />
      <p>{label}</p>
    </div>
  );
}

export function ErrorState({ label = 'Une erreur est survenue' }) {
  return (
    <div className="ui-state ui-state-error">
      <AlertTriangle size={28} />
      <p>{label}</p>
    </div>
  );
}

export function OfflineState({ label = 'Aucune donnée récente - appareil hors ligne ?' }) {
  return (
    <div className="ui-state ui-state-offline">
      <WifiOff size={28} />
      <p>{label}</p>
    </div>
  );
}
